import {
  showErrorToast,
  showSuccessToast,
} from "components/CustomAlerts/CustomToast";
import { Input } from "components/Input/Input";
import { useFormik } from "formik";
import { OrientacionI } from "interfaces/Orientacion";
import { useEffect } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { createOrientacionesSchema } from "schemas/orientaciones/createOrientacionSchema";
import { createTitulosSchema } from "schemas/titulos/createTitulosSchema";
import { postOrientacion, putOrientacion } from "services/orientacion";
import { postTitulo, putTitulo } from "services/titulos";
import { RootState } from "store/store";

interface Props {
  actionType: "create" | "edit" | undefined;
  onClose?: any;
  elemento?: OrientacionI;
  onSuccess?: (orientacion: OrientacionI) => void;
  showModal: boolean;
}

interface initialValues {
  id?: string | number;
  nombre: string;
}

export const OrientacionesABM = ({
  showModal,
  actionType,
  onClose,
  elemento,
  onSuccess,
}: Props) => {
  const isEditMode = actionType == "edit";
  const initialValues: initialValues = {
    nombre: "",
  };

  const renderInitialValues = async () => {
    let currentValues;

    if (isEditMode && elemento) {
      currentValues = {
        id: elemento?.id ?? "",
        nombre: elemento?.nombre ?? "",
      };
    } else {
      currentValues = initialValues;
    }
    setValues(currentValues);
  };

  const handleSubmitCreate = async (params: any) => {
    try {
      const newElement = await postOrientacion({ params });
      showSuccessToast("¡La orientacion fue creada con éxito!");
      if (onSuccess) onSuccess(newElement);
      onClose();
    } catch (err: any) {
      showErrorToast("La orientacion no pudo ser creada.");
      console.log(err.message);
    }
  };

  const handleSubmitEdit = async (params: any) => {
    try {
      console.log({ params });
      const newElement = await putOrientacion({ params });
      showSuccessToast("¡La orientacion fue editada con éxito!");
      if (onSuccess) onSuccess(newElement);
      onClose();
    } catch (err: any) {
      showErrorToast("La orientacion no pudo ser editada.", err.message);
    }
  };

  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    isSubmitting,
    handleSubmit,
    setValues,
    resetForm,
  } = useFormik({
    initialValues,
    validationSchema: createOrientacionesSchema,
    onSubmit: actionType == "create" ? handleSubmitCreate : handleSubmitEdit,
  });

  const { loadingAppData, tiposNormativa } = useSelector(
    (st: RootState) => st.appData,
  );

  useEffect(() => {
    resetForm();
    if (actionType) {
      renderInitialValues();
    }
  }, [actionType]);

  return (
    <>
      <Modal show={showModal} onHide={onClose} centered>
        <Modal.Header>
          <Modal.Title>
            {isEditMode ? "Editar Orientación" : "Nueva Orientación"}
          </Modal.Title>
        </Modal.Header>
        <form onSubmit={handleSubmit}>
          <Modal.Body>
            <Col>
              <Row>
                <Col>
                  <Input
                    id={"nombre"}
                    title="Nombre de la orientación"
                    required
                    onChange={handleChange}
                    onBlur={handleBlur}
                    values={values}
                    errors={errors}
                    touched={touched}
                    variant="gray-container"
                    size="lg"
                  />
                </Col>
              </Row>
            </Col>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="mx-3"
              variant="secondary"
              size="lg"
              onClick={onClose}
            >
              Cancelar
            </Button>
            <Button
              variant="primary"
              size="lg"
              className="user-submit-button"
              /* disabled={isSubmitting} */ type="submit"
            >
              {isEditMode ? "Guardar Cambios" : "Confirmar"}
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    </>
  );
};
